// FCM Provider - FCM 초기화 및 토큰 관리
import type { FC, ReactNode } from 'react';
import { useFCM } from '@/hooks/useFCM';

export const FCMProvider: FC<{ children: ReactNode }> = ({ children }) => {
  // useFCM 훅 호출 - 자동으로 토큰 등록 처리
  useFCM();

  return <>{children}</>;
};
